import { useCallback, useEffect, useRef, useState } from 'react';

const COPIED_FEEDBACK_MS = 2000;

export interface CopyFeedback {
    isCopied: boolean;
    copy: (text: string) => Promise<void>;
}

export const useCopyFeedback = (): CopyFeedback => {
    const [isCopied, setIsCopied] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const copy = useCallback(async (text: string) => {
        const didWrite = await writeClipboard(text);
        if (!didWrite) return;
        setIsCopied(true);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setIsCopied(false), COPIED_FEEDBACK_MS);
    }, []);

    return { isCopied, copy };
};

const writeClipboard = async (text: string): Promise<boolean> => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        return false;
    }
};
